import React from 'react';
import './ManagerLMSMain.css';

const ManagerLMSMain = () => (
  <div className="academy-page-shell manager-lms-main">
    <div className="lms-main-welcome">
      <h1>Welcome, Manager!</h1>
      <p className="lms-main-desc">Oversee teachers, students, and course progress. Use the sidebar to access your management tools.</p>
      <div className="lms-main-graphic manager"></div>
    </div>
  </div>
);

export default ManagerLMSMain;
